/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getNetworkModems = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Network Modem query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-network-modem/get?${queryString}`);
};

export const getNetworkModemByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-network-modem/${id}`);
};

export const getNetworkModemBySN = (sn) => {
  return API.get(`${getApiUrl()}/api/tkt1-network-modem/sn/${sn}`);
};

export const createNetworkModem = (networkModemData) => {
  return API.post(`${getApiUrl()}/api/tkt1-network-modem/`, networkModemData);
};

export const updateNetworkModem = (id, networkModemData) => {
  return API.put(`${getApiUrl()}/api/tkt1-network-modem/${id}`, networkModemData);
};

export const updateNetworkModemBySN = (sn, networkModemData) => {
  return API.put(`${getApiUrl()}/api/tkt1-network-modem/sn/${sn}`, networkModemData);
};

export const deleteNetworkModem = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-network-modem/${id}`);
};

export const tkt1NetworkModemService = {
  getNetworkModems,
  getNetworkModemByID,
  getNetworkModemBySN,
  createNetworkModem,
  updateNetworkModem,
  updateNetworkModemBySN,
  deleteNetworkModem
};
